import { render, staticRenderFns } from "./LinkGroupForm.vue?vue&type=template&id=447b9187&scoped=true"
import script from "./LinkGroupForm.vue?vue&type=script&lang=js"
export * from "./LinkGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447b9187",
  null
  
)

export default component.exports